import { Component } from '@angular/core';

@Component({
  selector: 'information-panel',
  templateUrl: './information-panel.component.html',
})
export class InformationPanelComponent {}
